/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Row_Feels_LikeInputs */

const en_ui_weather_row_feels_like = /** @type {(inputs: Ui_Weather_Row_Feels_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feels like`)
};

const de_ui_weather_row_feels_like = /** @type {(inputs: Ui_Weather_Row_Feels_LikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gefühlt`)
};

/**
* | output |
* | --- |
* | "Feels like" |
*
* @param {Ui_Weather_Row_Feels_LikeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_row_feels_like = /** @type {((inputs?: Ui_Weather_Row_Feels_LikeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Row_Feels_LikeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_row_feels_like(inputs)
	return de_ui_weather_row_feels_like(inputs)
});